import { Title1 } from 'components/Text';

//styles
import {
  HeaderSectionWrapper,
  HeaderSectionContainer,
  HeaderSectionContent,
  HeaderSubtitle,
} from './HeaderSection.styles';

export default function HeaderSection({
  content = { description: null },
  width,
}) {
  return (
    <HeaderSectionWrapper>
      <HeaderSectionContainer>
        <HeaderSectionContent width={width}>
          {content.title && <Title1>{content.title}</Title1>}
          {content.description && (
            <HeaderSubtitle>{content.description}</HeaderSubtitle>
          )}
        </HeaderSectionContent>
      </HeaderSectionContainer>
    </HeaderSectionWrapper>
  );
}

export { HeaderSection };
